import BaseEventGroups from 'cio/utils/base-events';

const mparticleEventNames = [
  'customer_subscribed',
  'customer_unsubscribed',
  'email_sent',
  'email_delivered',
  'email_opened',
  'email_clicked',
  'email_converted',
  'email_bounced',
  'email_spammed',
  'email_failed',
  'in_app_sent',
  'in_app_opened',
  'in_app_clicked',
  'in_app_converted',
  'in_app_failed',
  'in_app_undeliverable',
  'push_sent',
  'push_delivered',
  'push_opened',
  'push_clicked',
  'push_converted',
  'push_bounced',
  'push_failed',
  'sms_sent',
  'sms_delivered',
  'sms_clicked',
  'sms_converted',
  'sms_bounced',
  'sms_failed',
];

// 1. Filter event groups that have at least one mParticle event
// 2. Filter events in those groups to include only mparticle events
export default BaseEventGroups.filter((group) =>
  mparticleEventNames.any((eventName) => group.items.map((i) => i.value).includes(eventName)),
).map((group) => ({
  ...group,
  items: group.items.filter((item) => mparticleEventNames.includes(item.value)),
}));
